import React from 'react';
import { FormattedNumber } from 'react-intl';

import { Typography } from 'antd';

import CustomMaskedInput from 'components/MaskedOutput/index';

interface IProps {
  value: any;
  format?: string;
  disableSymbol?: boolean;
}

const ColoredFormattedNumber: React.FC<IProps> = ({ value, format, disableSymbol }) => {
  const fmt = format || 'BRL';

  return (
    <Typography.Text className={value >= 0 ? 'text-(--uizz-antd-color-success)' : 'text-(--uizz-antd-color-error)'}>
      {disableSymbol ? (
        <CustomMaskedInput mask='money' value={value} />
      ) : (
        <FormattedNumber value={value} format={fmt} />
      )}
    </Typography.Text>
  );
};

export default ColoredFormattedNumber;
